import { patientMixins } from '@/patient-mixins'
import { mixins } from '@/mixins'
import moment from 'moment'
import { getIntegratorWorkTimeFrom, getIntegratorWorkTimeTo } from '@/composables/currentUser'

export const patientAppointmentCalendarMixins = {
  methods: {
    getTitle(schedule, showDoctorName = true, hidePhone = false) {
      const doctor = schedule.doctor && showDoctorName ? '[Доктор: ' + schedule.doctor.full_name + ']' : ''
      const age = patientMixins.methods.getPatientAge(schedule.patient)
      const cardNumber = schedule.patient && schedule.patient.patient_card_number
        ? schedule.patient.patient_card_number : null
      const patient = schedule.patient
        ? schedule.patient.full_name + (cardNumber ? ` - №${cardNumber}` : '') + (age ? ' - ' + age : '')
        : ''
      const phone = (
        !hidePhone
        && !mixins.methods.hidePatientPhoneNumberForDoctor() && schedule.patient && schedule.patient.full_phone
        && (
          ['root', 'sys_admin'].includes(mixins.methods.getUserRoleType())
          || !mixins.methods.getPatientContactViewPasswordSendingMethod()
        )
      )
        ? 'Телефон: ' + schedule.patient.full_phone : ''
      const note = schedule.note ? 'Примечание: ' + schedule.note : ''
      const phrases = []

      if (doctor) {
        phrases.push(doctor)
      }

      if (patient) {
        phrases.push(patient)
      }

      if (phone) {
        phrases.push(phone)
      }

      if (note) {
        phrases.push(note)
      }

      return phrases.join(' ')
    },
    getTimeInterval() {
      const settings = mixins.methods.getUserCalendarSettingsFromStorage()
      return settings && settings.timeInterval ? settings.timeInterval : 10
    },
    getTimeStages() {
      const oneHour = 60
      const currentHour = moment().format('HH')
      const currentMinutes = moment().format('mm')
      const currentTimeAsNumber = (currentHour * oneHour) + (currentMinutes * 1)
      let minutesFrom = getIntegratorWorkTimeFrom() // in minutes 08:00
      let minutesTo = getIntegratorWorkTimeTo() // in minutes 21:50
      const interval = patientAppointmentCalendarMixins.methods.getTimeInterval()
      let currentStage = minutesFrom
      const formattedStages = []
      while (currentStage <= (minutesTo + interval)) {
        const currentStageHours = Math.ceil(currentStage / oneHour)
        const currentStageMinutes = currentStage % oneHour
        let currentStageAsNumber = 0;
        let formattedCurrentStage = '';
        if (currentStageMinutes > 0) {
          formattedCurrentStage = (currentStageHours - 1) + ':' + (
            currentStageMinutes < 10 ? '0' + currentStageMinutes : currentStageMinutes
          )
          currentStageAsNumber = ((currentStageHours - 1) * oneHour) + currentStageMinutes;
        } else {
          formattedCurrentStage = currentStageHours + ':' + currentStageMinutes + '0'
          currentStageAsNumber = (currentStageHours * oneHour) + currentStageMinutes;
        }
        currentStage += interval
        formattedStages.push({
          current_stage_as_text: formattedCurrentStage,
          current_stage_as_number: currentStageAsNumber,
          showCurrentTimeLine: (currentStageAsNumber > currentTimeAsNumber - interval)
            && (currentStageAsNumber - interval <= currentTimeAsNumber - interval)
        })
      }
      return formattedStages
    }
  }
}
